import { tw } from 'utils/classnames'
import { LFS_URL } from '@web/utils/env'
import { useTranslations } from 'next-intl'
import Image from 'next/image'

interface ImageBannerProps {
  className?: string
}

export function ImageBanner({ className }: ImageBannerProps) {
  const t = useTranslations('pages.knitting.cards')

  return (
    <div
      className={tw('rounded-2 relative z-0 h-[278px] w-full overflow-hidden md:mb-4', className)}
    >
      <div
        className={tw(
          'relative rounded-2 h-[45px] w-1/3 object-cover object-top md:absolute md:bottom-0 md:z-0 md:h-full md:w-full',
        )}
      >
        <Image
          src={`${LFS_URL}/web/banners/CF_3D-PaperCrafting_SEO_Image2-Banner_01.jpg`}
          alt="Knitting Patterns"
          fill
          priority
          unoptimized
          sizes="100vw"
          className="h-full w-full rounded-2 object-cover object-top"
        />
        <div className="absolute inset-0 to-cf-black/20 from-transparent bg-gradient-to-b" />
      </div>
      <div className="text-cf-white bottom-0 z-10 flex w-full flex-row justify-between md:absolute md:px-10 md:py-5">
        <div className="hidden font-bold uppercase md:block">{t('info')}</div>
      </div>
    </div>
  )
}
